export enum AnalyticsSource {
  MoreMenu = 'More Menu',
}
